export default "__VITE_ASSET__dBhvMVYn__"